import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import * as R from 'ramda';


import { getProfileFiles, getProfilePicture } from '../../actions/user-api';
import { FileTypes } from '../../constants/utils/fileTypes';


import logo_hr from './../../assets/images/brand/assista_horizontal-punchout.svg';
import logo from './../../assets/images/brand/assista.svg';
import { Avatar } from './../../_common/avatar';


export const Navbar = ({ roles }) => {
    const router = useSelector(state => state.router);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();

    const [widthIsBigger, setWidthIsBigger] = useState(false);

    useEffect(() => {

        // if (!R.isNil(user.user)) {

        //     getProfileFiles(user.user.id)
        //         .then(data => {
        //             const profilePictures = data.filter(file => file.fileType === FileTypes.ProfilePicture);
        //             const fileName = !R.isEmpty(profilePictures) ? profilePictures[profilePictures.length - 1].fileName : "";

        //             dispatch(getProfilePicture(user.user.id, fileName));

        //         });
        // }

    }, []);

    useEffect(() => {
        if (!R.isNil(user.profilePicture)) {
            let i = new Image();
            i.onload = function () {
                setWidthIsBigger(i.width > i.height);
            };
            i.src = user.profilePicture;
        }
    }, [user.profilePicture]);


    return (
			<React.Fragment>
				<header className="aside navbar navbar-expand-lg text-white py-4 navbar-dark">
					<div className="container-fluid justify-content-between align-item-center d-lg-flex flex-lg-column h-100">
						<Link className="navbar-brand mx-lg-auto mb-lg-auto" to="/backoffice">
							<img className="img-fluid" src={logo_hr} alt="Assist@" width="180" />
							{/* <img className="img-fluid d-none d-lg-block" src={logo} alt="Assist@" width="146" /> */}
							<h1 className="sr-only visually-hidden">Assist@: Menu</h1>
						</Link>
						<div className="d-flex align-items-center">
							<button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
								<span className="navbar-toggler-icon"></span>
							</button>
						</div>
						<div className={"collapse navbar-collapse flex-column mt-4"} id="navbar-collapse">
							<nav className="card w-100 rounded-cta bg-stage flex-grow-0 mb-auto h-100 border-0">
								<h1 className="sr-only visually-hidden">Menu: navigation</h1>
								<div className="nav-item text-center">
									<div className={"d-flex mx-auto h-6 w-6 rounded-circle font-weight-bold mb-2 shadow" + (R.isNil(user.profilePicture) ? " bg-gradient-stage" : "")} role="button" data-toggle="modal" data-target="#changeavatar">
										{!R.isNil(user.profilePicture) ? <img className={"img-fluid h-100 w-100 rounded-inherit" + (widthIsBigger ? " img-contain bg-white border" : " img-cover")} alt="avatar" src={user.profilePicture} /> : <i className="eva eva-image-2 h2 lh-1 m-auto icon-default"></i>}
									</div>
									<div className="h3 font-weight-bold lh-1">{!R.isNil(user.user) ? `${user.user.firstName} ${user.user.lastName}` : "The backoffice"}</div>
									<ul className="nav navbar-inline align-items-center justify-content-around container-paper mx-auto">
										<NavLink className={"nav-item inline-item o-80 o-100--hover"} activeClassName="rounded-max o-100 active" to="/backoffice/settings">
											<div className="nav-link p-2 mb-0 lh-1">
												<i className="eva eva-settings-2-outline h3 lh-1 my-auto icon-default"></i>
											</div>
										</NavLink>
										<div
											role="button"
											className={"nav-item inline-item o-70 o-100--hover"}
											onClick={() => {
												localStorage.removeItem("access_token");
												setTimeout(() => {
													window.location = "/index";
												}, 100);
											}}>
											<div className="nav-link p-2 mb-0 lh-1">
												<i className="eva eva-power-outline h3 lh-1 my-auto icon-default"></i>
											</div>
										</div>
									</ul>
								</div>
								<div className="nav-item show">
									<div className="card rounded-0 bg-faded text-body text-center">
										<div className="card-header">
											<div className="h6 o-60 font-weight-bold lh-1 mb-1">Entité</div>
											<div className="h4 text-uppercase font-weight-bold lh-1 mb-0">backoffice</div>
										</div>
									</div>
									{roles.includes("ADMIN") ? (
										<ul className="card-body pb-0 navbar-nav">
											<NavLink className="nav-item og-item" to="/backoffice/dossiers?page=1">
												<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit"}>
													<span className="font-weight-demi text-uppercase pr-3">Dossiers</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
												{/* <div className="menu mt-2 px-0">
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50 mb-3">
                                                        <span className="grid-column-4">Dossiers en cours</span>
                                                        <span className="ml-auto">3</span>
                                                    </div>
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50">
                                                        <span className="grid-column-4">Dossiers terminé</span>
                                                        <span className="ml-auto">10</span>
                                                    </div>
                                                </div> */}
											</NavLink>
											<NavLink className="nav-item og-item" to="/backoffice/selfcare?page=1">
												<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit"}>
													<span className="font-weight-demi text-uppercase pr-3">Espace famille</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
											</NavLink>
											<NavLink className="nav-item og-item" to="/backoffice/clients?page=1">
												<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit"}>
													<span className="font-weight-demi text-uppercase pr-0 ls-n1">Gestion d'accès</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
												{/* <div className="menu mt-2 px-0">
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50 mb-3">
                                                        <span className="grid-column-4">Anticipa</span>
                                                        <span className="ml-auto">3</span>
                                                    </div>
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50">
                                                        <span className="grid-column-4">Facilita</span>
                                                        <span className="ml-auto">6</span>
                                                    </div>
                                                </div> */}
											</NavLink>
											<NavLink className="nav-item og-item" to="/backoffice/partners">
												<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit"}>
													<span className="font-weight-demi text-uppercase pr-3">partenaires</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
												{/* <div className="menu mt-2 px-0">
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50 mb-3">
                                                        <span className="grid-column-4">Notaire</span>
                                                        <span className="ml-auto">3</span>
                                                    </div>
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50">
                                                        <span className="grid-column-4">Agences Funéraires</span>
                                                        <span className="ml-auto">6</span>
                                                    </div>
                                                </div> */}
											</NavLink>
											<NavLink className="nav-item" to="/backoffice/paiement?page=1">
												<div className={"nav-link grid grid-2 gx-2 w-100 justify-content-between mb-0 text-inherit"}>
													<span className="font-weight-demi text-uppercase pr-3">paiement</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
												{/* <div className="menu mt-2 px-0">
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50 mb-3">
                                                        <span className="grid-column-4">Clients</span>
                                                        <span className="ml-auto">3</span>
                                                    </div>
                                                    <div role="button" className="grid grid-5 gx-1 align-items-center h6 font-weight-bold o-50">
                                                        <span className="grid-column-4">Partenaires</span>
                                                        <span className="ml-auto">6</span>
                                                    </div>
                                                </div> */}
											</NavLink>
											<NavLink className={"nav-item"} to="/backoffice/impression">
												<div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
													<span className="font-weight-demi text-uppercase">Impressions</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
											</NavLink>
										</ul>
									) : (
										<ul className="card-body pb-0 navbar-nav">
											<NavLink className={"nav-item"} to="/backoffice/impression">
												<div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
													<span className="font-weight-demi text-uppercase">Impressions</span>
													<i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto ml-auto"></i>
												</div>
											</NavLink>
										</ul>
									)}
								</div>
								{roles.includes("ADMIN") && (
									<NavLink className="btn btn-white-primary text-primary m-2 px-3 rounded-sm mt-auto" to="/backoffice/configuration">
										<div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
											<span className="font-weight-demi text-uppercase align-middle fs-3 ls-n1">Configuration</span>
											<i className="eva eva-options-outline fs-sm lh-1 my-auto ml-auto align-middle"></i>
										</div>
									</NavLink>
								)}
							</nav>
						</div>
					</div>
				</header>
				<Avatar user={user.user} profilePicture={user.profilePicture} profilePictureDocument={user.documents.find((d) => d.fileType === FileTypes.ProfilePicture)} />
			</React.Fragment>
		);
};